import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Wrench, Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <div className="w-9 h-9 bg-yellow-400 flex items-center justify-center rounded-sm group-hover:rotate-12 transition-transform">
            <Wrench className="w-5 h-5 text-black" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <span className="font-heading font-extrabold text-lg tracking-tight text-white">ESMS</span>
            <span className="block text-[9px] uppercase tracking-[0.25em] text-yellow-400 font-bold">Easy Stop Mobile Service</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.path}
              to={n.path}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`text-sm font-medium uppercase tracking-wide transition-colors ${
                location.pathname === n.path ? "text-yellow-400" : "text-neutral-300 hover:text-white"
              }`}
            >
              {n.label}
            </Link>
          ))}
          <button
            data-testid="navbar-book-button"
            onClick={() => navigate("/book")}
            className="bg-yellow-400 text-black text-sm font-bold uppercase tracking-wide px-6 py-2.5 rounded-sm hover:bg-yellow-500 transition-colors"
          >
            Book Now
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-5 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <Link
              key={n.path}
              to={n.path}
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="text-base font-medium uppercase tracking-wide text-neutral-200"
            >
              {n.label}
            </Link>
          ))}
          <button
            data-testid="mobile-book-button"
            onClick={() => navigate("/book")}
            className="bg-yellow-400 text-black font-bold uppercase tracking-wide px-6 py-3 rounded-sm"
          >
            Book Now
          </button>
        </div>
      )}
    </header>
  );
}
